import React, { useEffect, createElement } from 'react';
import { LandingPage } from './components/LandingPage';
export function App() {
  useEffect(() => {
    // Google Tag Manager (gtag.js)
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17810960450';
    document.head.appendChild(script1);
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-17810960450');
    `;
    document.head.appendChild(script2);
    // Facebook Pixel
    const script3 = document.createElement('script');
    script3.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '236230670228240');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script3);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=236230670228240&ev=PageView&noscript=1"
    />`;
    document.body.appendChild(noscript);
    // Set page title
    document.title = 'Activa tu Energía Femenina | Yo Soy la Mujer que Atrae - Programa de 21 Días';
    // Set SEO and Open Graph meta tags
    const metaTags = [
    // Primary SEO
    {
      name: 'description',
      content: 'Activa tu Energía Femenina y Manifiesta la Vida que Anhelas. Programa de 21 días de transformación emocional, gratitud y productividad. Incluye audios, ebook y ejercicios prácticos. Promo especial $16.99.'
    }, {
      name: 'keywords',
      content: 'energía femenina, manifestación, amor propio, relaciones conscientes, abundancia, reprogramación subconsciente, alma en expansión, danielle e. s., programa 21 días, magnetismo femenino, sanar heridas'
    }, {
      name: 'author',
      content: 'Danielle E. S. - Yo Soy la Mujer que Atrae'
    }, {
      name: 'robots',
      content: 'index, follow'
    },
    // Open Graph (Facebook, WhatsApp, Instagram)
    {
      property: 'og:title',
      content: 'Activa tu Energía Femenina | Yo Soy la Mujer que Atrae'
    }, {
      property: 'og:description',
      content: 'Programa de 21 días para activar tu energía femenina, recuperar tu poder y manifestar la vida que anhelas. Incluye audios, ebook y bonos exclusivos.'
    }, {
      property: 'og:type',
      content: 'product'
    }, {
      property: 'og:image',
      content: 'https://cdn.magicpatterns.com/uploads/qbJy231BvdXRV2UniJa3aM/hf_20260208_195520_c7bb8ee2-86fa-45c1-8c00-3f3dd3334691.png'
    }, {
      property: 'og:locale',
      content: 'es_ES'
    }, {
      property: 'og:site_name',
      content: 'Yo Soy la Mujer que Atrae'
    }, {
      property: 'product:price:amount',
      content: '16.99'
    }, {
      property: 'product:price:currency',
      content: 'USD'
    },
    // Twitter Card
    {
      name: 'twitter:card',
      content: 'summary_large_image'
    }, {
      name: 'twitter:title',
      content: 'Activa tu Energía Femenina | Yo Soy la Mujer que Atrae'
    }, {
      name: 'twitter:description',
      content: 'Programa de 21 días para activar tu energía femenina y manifestar abundancia. Promo especial $16.99.'
    }, {
      name: 'twitter:image',
      content: 'https://cdn.magicpatterns.com/uploads/qbJy231BvdXRV2UniJa3aM/hf_20260208_195520_c7bb8ee2-86fa-45c1-8c00-3f3dd3334691.png'
    }];
    metaTags.forEach(({
      property,
      name,
      content
    }: any) => {
      const selector = property ? `meta[property="${property}"]` : `meta[name="${name}"]`;
      let meta = document.querySelector(selector) as HTMLMetaElement | null;
      if (!meta) {
        meta = document.createElement('meta');
        if (property) meta.setAttribute('property', property);
        if (name) meta.setAttribute('name', name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    });
    // Add JSON-LD structured data for SEO
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (!existingScript) {
      const jsonLd = document.createElement('script');
      jsonLd.type = 'application/ld+json';
      jsonLd.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: 'Activa tu Energía Femenina - Programa de 21 Días',
        description: 'Programa de transformación personal para activar tu energía femenina, recuperar tu valor emocional y atraer relaciones sanas. Incluye audio guiado, cuaderno de ejercicios y método paso a paso.',
        image: 'https://cdn.magicpatterns.com/uploads/qbJy231BvdXRV2UniJa3aM/hf_20260208_195520_c7bb8ee2-86fa-45c1-8c00-3f3dd3334691.png',
        brand: {
          '@type': 'Brand',
          name: 'Yo Soy la Mujer que Atrae'
        },
        author: {
          '@type': 'Person',
          name: 'Danielle E. S.'
        },
        offers: {
          '@type': 'Offer',
          price: '16.99',
          priceCurrency: 'USD',
          availability: 'https://schema.org/InStock',
          url: 'https://almaenexpansion.com/products/activa-tu-energia-femenina'
        },
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '5',
          reviewCount: '412'
        }
      });
      document.head.appendChild(jsonLd);
    }
  }, []);
  return <LandingPage data-id="element-0" />;
}